import { css } from '@/styled-system/css';

export const container = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'default',
});

export const summaryRow = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'tightest',
});

export const deltaIcon = css({
  width: '500',
  height: '500',
  flexShrink: 0,
});

export const summaryDelta = css({
  fontSize: 'heading-sm',
  fontWeight: 'bold',
  lineHeight: 'heading-sm',
});

export const description = css({
  fontSize: 'body',
  color: 'text.neutral',
  lineHeight: 'body',
});

export const colorCheaper = css({
  color: 'brand.primary',
});

export const colorMore = css({
  color: 'red.400',
});

export const inlineLink = css({
  color: 'brand.primary',
  fontWeight: 'bold',
  textDecoration: 'none',
  _hover: {
    textDecoration: 'underline',
  },
  _focusVisible: {
    outlineWidth: 'thick',
    outlineStyle: 'solid',
    outlineColor: 'brand.primary',
    outlineOffset: '50',
    borderRadius: 'sm',
  },
});

export const averagesCardHeader = css({
  fontSize: 'body-sm',
  fontWeight: 'bold',
  color: 'text.neutral',
  marginTop: 0,
  marginBottom: 'tighter',
});

export const averagesList = css({
  listStyle: 'none',
  padding: 0,
  margin: 0,
});

export const areaRow = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 'default',
  minWidth: 0,
  paddingBlock: 'tightest',
  fontSize: 'body',
});

export const areaRowLink = css({
  color: 'brand.primary',
  fontWeight: 'bold',
  textDecoration: 'none',
  _hover: {
    textDecoration: 'underline',
  },
  _focusVisible: {
    outlineWidth: 'thick',
    outlineStyle: 'solid',
    outlineColor: 'brand.primary',
    outlineOffset: '50',
    borderRadius: 'sm',
  },
});

export const areaRowValue = css({
  color: 'text.neutral',
  fontWeight: 'bold',
});
